<template>
    <div>
        <agent-selector :reservation="reservation" @sideBarOriginAndSegmentIsReadyToSubmit="($event) => sideBarOriginAndSegmentIsReadyToSubmit = $event"></agent-selector>

        <div class="bg-lightest dark font-weight-600 px-3 py-3 fs-small d-flex flex-row align-items-center justify-content-between pointer w-100">
            <div class="d-flex flex-row align-items-center">
                <i class="ico ico-ticket color-6 fs-larger"></i>
                <span>VOUCHER CODE</span>
            </div>

            <div class="w-50 d-flex justify-content-end">
                <input type="text" class="w-100 px-2 py-1" v-model="reservation.BookingOperatorCode">
            </div>
        </div>

    <cost-list :reservation="reservation" :noTicketsSelected="perOrderNoCategories"></cost-list>

        <!-- Promocode -->
    <promocode-input :reservation="reservation" :enablePromocode="true" :noTicketsSelected="perOrderNoCategories" class="mt-2"></promocode-input>

    <total-and-pay :reservation="reservation" :selectedAgentComissions="selectedAgentComissions" :noTicketsSelected="perOrderNoCategories" :sideBarOriginAndSegmentIsReadyToSubmit="sideBarOriginAndSegmentIsReadyToSubmit"></total-and-pay>
    </div>
</template>

<script>
    import AgentSelector from './Summary/AgentSelector'
    import CostList from './Summary/CostList'
    import TotalAndPay from './Summary/TotalAndPay'
    import PromocodeInput from '@/tools/promocode/promocodeInput'

    export default {
        data() {
            return {
                bookingGenderPrices: null,
                sideBarOriginAndSegmentIsReadyToSubmit: false
            }
        },
        props: {
            reservation: {
                type: Object
            },
            selectedAgentComissions: {
                type: Object,
                default: null
            }
        },
        created() {
            this.bookingGenderPrices = this.reservation.bookingGenderPrices;
        },
        computed: {
            perOrderNoCategories() {
                // Enable CostList when Per Order and only the base line exists (length === 1)
                const list = this.bookingGenderPrices || [];
                const isPerOrderSingleBase = list.length === 1 && list[0] && list[0].genderPriceType === 1;
                if (isPerOrderSingleBase) return false;

                return this.noTicketsSelected;
            },        
            noTicketsSelected() {
                let total = 0;

                if (this.isSomeRulesPaxPerBooking && !this.accessPermissionFilter(['admin'])) {
                    for (let personTypes of this.bookingGenderPrices) {
                        total += personTypes.quantityToBook;
                    }

                    if (total != 0) {
                        if (this.reservation.event.rejectBookingBasedOnMinMax) {
                            if (total < this.reservation.event.minimumPaxPerBooking) {
                                return true;
                            } else if (this.reservation.event.maximumPaxPerBooking != 0) {
                                if (total > this.reservation.event.maximumPaxPerBooking) {
                                    return true;
                                }  else {
                                    return false;
                                }
                            } else {
                                return false;
                            }      
                        } 
                    } else {
                        return true;
                    }
                } else {
                    let output = true;
                    for (let personTypes of this.bookingGenderPrices) {
                        if (personTypes.quantityToBook > 0) {
                            output = false;
                        }
                    }

                    return output;
                }
            },
            isSomeRulesPaxPerBooking() {
                if (this.reservation.event.minimumPaxPerBooking > 0 || this.reservation.event.maximumPaxPerBooking > 0) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        components: {
            AgentSelector,
            CostList,
            TotalAndPay,
            PromocodeInput
        }
    }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// ReservationSummary.vue?5ac07610